/**
 * legalPaths — ОДИН реестр адресов наших собственных юридических документов
 * (WEB-2256, шрам WEB-1288).
 *
 * ЗАЧЕМ. Ссылка на документ и маршрут, по которому документ открывается, —
 * две разные правки в двух разных файлах. Забыть вторую легко, а Caddy отдаёт
 * одностраничное приложение на ЛЮБОЙ путь, и последнее правило роутера
 * (`/:quizSlug`) ловит любой одиночный сегмент: человек, решивший прочитать
 * документ, под которым обязан подписаться, видел страницу «квиз не найден»
 * от публичного плеера (WEB-1288).
 *
 * ПОЧЕМУ РЕЕСТР, А НЕ ЛИТЕРАЛЫ ПО МЕСТУ. Сторож `registerLegalLinks.web1288`
 * выводил первый конец («что человек реально нажмёт») из ОДНОГО файла —
 * `pages/Register.tsx`. Пачка 45 добавила те же ссылки в подвал входа
 * (`components/auth/AuthLayout.tsx`), в подвал публичных страниц воронок
 * (`components/public/PublicFooter.tsx`) и в лестницу адреса политики для
 * баннера согласия (`utils/analytics/consentPolicyUrl.ts`) — и сторож их не
 * видел по построению: снять маршрут `/health-data` он позволял молча. Теперь
 * первый конец — этот файл, а копии литералов по дереву запрещены тем же
 * сторожем (грепом, а не списком мест).
 *
 * ГДЕ ЛИТЕРАЛ ОСТАЁТСЯ НАМЕРЕННО: `router/index.tsx`. Это ВТОРОЙ конец
 * правила («что реально открывается»), и он обязан быть независим от первого:
 * роутер, собранный из того же реестра, сделал бы сверку тавтологией —
 * сторож не смог бы покраснеть никогда.
 */

/** «Условия использования». */
export const LEGAL_TERMS_PATH = '/terms';

/** «Политика конфиденциальности». */
export const LEGAL_PRIVACY_PATH = '/privacy';

/**
 * «Данные о здоровье» — самостоятельный документ (WEB-2162 п.1–2). Закон
 * штата Вашингтон требует именно отдельный документ и ссылку на него с
 * главной страницы, а не якорь внутри политики.
 */
export const LEGAL_HEALTH_DATA_PATH = '/health-data';

/** Все адреса документов: перечень под самопроверкой `legalPaths.test.ts`. */
export const LEGAL_PATHS = [
  LEGAL_TERMS_PATH,
  LEGAL_PRIVACY_PATH,
  LEGAL_HEALTH_DATA_PATH,
] as const;

export type LegalPath = (typeof LEGAL_PATHS)[number];
